import React from 'react';

const AvailableContentLeft = () => {
  return <section className="text-left" style={{
    marginTop: '25px',
    paddingLeft: '30px',
    paddingTop: '15px',
    paddingBottom: '25px',
    borderTop: '1px solid #ddd',
  }}>
    <h2>
      Instructional Content
    </h2>
    <ul style={{ lineHeight: '2' }}>
      <li>Long-Form Video Lessons</li>
      <li>Short-Form Video Lessons</li>
      <li>Grammar-in-Context Videos</li>
      <li>Slideshow Presentations</li>
      <li>Memorable Images</li>
      <li>Definition Cards</li>
      <li>Music Videos</li>
    </ul>
  </section>;
}

export default AvailableContentLeft;
